const taskActionTypes = {
  SET_TASKS: "SET_TASKS",
};

export default taskActionTypes;
